import $ from "jquery";
window.$ = window.jQuery = $;
import "slick-carousel";
import * as mobilefix from "./mobilefix";
// import * as wmbox from "./wmbox";
import * as animations from "./animations";
import * as parallax from "./parallax";
import * as loader from "./loader";
import * as map from "./map";
import * as readmore from "./readmore";
import "./tools";

$(document).ready(function() {

	loader.load();

	parallax.homeParallax();
	if ($('#map').length) map.loadMap();
	readmore.load();

	var $logo = $('#header-logo');
	var menuburger = $('#header-menu');
	var menuLinesAnimation = animations.menuLinesAnimation();
	var $menu = $('#menu');

	$('.fullpage-footer-scroll').on('click', function() {
		$('.fullpage-footer-scroll').parents('.fullpage').next('.normalpage').scrollTo();
	});

	$('.footerpage-icon').on('click', function() {
		$('.footerpage').scrollTo();
	});

	menuburger.on('mouseenter', function() {
		if ($menu.is(':hidden')) menuLinesAnimation.expand();
		else menuLinesAnimation.rotate();
	}).on('mouseleave', function() {
		if ($menu.is(':hidden')) menuLinesAnimation.contract();
	}).on('click', function(e) {
		e.preventDefault();
		menuLinesAnimation.toggleOpenClose();
	});

	$('.menu-close-bg').on('click', function(e) {
		e.preventDefault();
		menuLinesAnimation.toggleOpenClose();
	});

	$('.gallerypage').slick({
		slidesToShow: 4,
		responsive: [
		{
		  breakpoint: 1440,
		  settings: {
		    slidesToShow: 3
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
		    slidesToShow: 1
		  }
		}]
	});

	$('.list-filter').on('click', function(e) {
		e.preventDefault();
		const filter = $(this);
		const intro = $('.normalpage-intro');
		const img = $('.normalpage-hero-img');
		const list = $('.list');
		filter.addClass('active').siblings().removeClass('active');
		$('.menu-sublist-el').removeClass('active').filter('[href="'+filter.attr('href')+'"]').addClass('active');
		$.ajax({
		    type: 'POST',
		    url: filter.prop('href'),
		    success: function (response) {
		    	const dom = $(response);
		    	var currentIntroHeight = intro.outerHeight();
		        intro.html(dom.find('.normalpage-intro').html()).slideDown();
		    	var nextIntroHeight = intro.outerHeight();
		    	intro.css('height', currentIntroHeight).animate({
		    		height: nextIntroHeight
		    	}, 500, function() {
		    		intro.css('height','');
		    	});
		        img.fadeOut(500, function() {
		        	img.css({'background-image': dom.find('.normalpage-hero-img').css('background-image')}).fadeIn(500);
		        });
		        list.fadeOut(500, function() {
		        	list.html(dom.find('.list').html()).fadeIn(500);
		        });
		    },
		    error: function (response) {
		        console.error('error', response);
		    }
		});
	});
	$('.menu-list-el').on('click', function(e) {
		const el = $(this);
		const sublist = el.siblings('.menu-sublist');
		if (sublist.length) {
			e.preventDefault();
			if (el.hasClass('opened')) {
				sublist.slideUp(350, function() {
					el.removeClass('opened');
				});
			} else {
				el.addClass('opened');
				sublist.slideDown(350);
			}
		}
	})
	
});
